import request from '@/utils/request'

let Hproduct_subcategoryApi = {

  /*产品子分类列表*/
  list(data) {
    return request._post('/shop/plus.hproduct_subcategory.Index/index', data);
},
/*添加产品子分类*/
add(data) {
    return request._post('/shop/plus.hproduct_subcategory.Index/add', data);
},
/*修改产品子分类*/
edit(data) {
    return request._post('/shop/plus.hproduct_subcategory.Index/edit', data);
},
/*删除产品子分类*/
del(data) {
    return request._post('/shop/plus.hproduct_subcategory.Index/del', data);
},
/*产品子分类详情*/
detail(data) {
  return request._post('/shop/plus.hproduct_subcategory.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.hproduct_subcategory.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.hproduct_subcategory.Setting/getSetting', data, errorback);
    },
}
export default Hproduct_subcategoryApi;



// WEBPACK FOOTER //
// ./src/api/hproduct_subcategory.js